// extracted by mini-css-extract-plugin
export var legendIndicator = "_c5-1";
export var legendRight = "_c5-0";